import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ForbiddenPage from '../pages/ForbiddenPage';

export default function PrivateRoute({ children, permission }) {
  const { user, loading, hasPermission } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  // Fehlt das nötige Bereichs-Recht, kommt die 403-Seite statt des halb geladenen Panels.
  if (permission && !hasPermission(permission)) return <ForbiddenPage />;
  return children;
}
